// Presentation only: all assessments and amounts come from the analytics response.
const metric = (item, key) => (item && item.evidence || []).find(row => row.metric === key);

function cards(data) {
    const result = [], items = data.insights;
    const cost = items.find(item => ['hour_cost', 'accepted_day_cost'].includes(item.id));
    if (cost) result.push({kind: 'cost', item: cost, metric: metric(cost, data.context.cost_basis === 'accepted_days' ? 'salary_per_accepted_day' : 'salary_per_hour')});
    const money = items.find(item => ['payroll_effects', 'payroll_total'].includes(item.id));
    if (money) result.push({kind: 'money', item: money, metric: metric(money, 'salary_minor')});
    const objects = items.filter(item => item.object_id).slice().sort((a, b) => Math.abs(metric(b, 'salary_minor').delta) - Math.abs(metric(a, 'salary_minor').delta) || a.object_id - b.object_id);
    if (objects.length) result.push({kind: 'objects', item: objects[0], items: objects.slice(0, 3)});
    // A reliable change in working hours must remain visible even when money is incomplete.
    if (!result.length && items.length) {
        const item = items[0];
        result.push({kind: 'observation', item, metric: metric(item, 'hours_per_day') || metric(item, 'accepted_days') || item.evidence[0]});
    }
    return result;
}

function effects(data) {
    const d = data.decomposition;
    if (!d) return [];
    const daily = data.context.cost_basis === 'accepted_days';
    const values = [daily ? d.accepted_days_effect_minor : d.hours_effect_minor, daily ? d.day_cost_effect_minor : d.hour_cost_effect_minor];
    const max = Math.max(...values.map(Math.abs), 1);
    return values.map((amount, index) => ({key: index, amount: amount / 100,
        label: index ? `Средняя стоимость ${daily ? 'дня' : 'часа'}` : `Количество ${daily ? 'принятых дней' : 'часов'}`,
        style: {left: `${amount < 0 ? 50 - Math.abs(amount) / max * 50 : 50}%`, width: `${Math.abs(amount) / max * 50}%`}}));
}

function emptyMessage(data) {
    const pair = [data.totals[data.context.baseline_index], data.totals[data.context.current_index]];
    const comparable = [['salary_minor', ['salary_minor']], ['hours_per_day', ['hours', 'days']],
        ...(data.context.cost_basis === 'accepted_days' ? [['accepted_days', ['accepted_days']]] : [])]
        .some(([metric, required]) => pair.every(row => row && !row.stale && row[metric] != null && required.every(key => row.complete[key])));
    return comparable ? 'Существенных изменений по доступным сопоставимым показателям не выявлено.' : 'Недостаточно данных для надёжных выводов.';
}
function warningLabel(warning) {
    const labels = {object_comparability: 'Часть объектов несопоставима', object_allocation: 'Часть сумм не распределена',
        unknown_category: 'Доля ИТР недоступна', unknown_location: 'Доля базы недоступна',
        provisional: 'Предварительные результаты', incomplete: 'Есть неполные показатели',
        zero_hours: 'Стоимость часа недоступна: нулевые часы', zero_accepted_days: 'Стоимость дня недоступна: нулевые дни',
        zero_days: 'Средние часы недоступны: нулевые рабочие дни'};
    return labels[warning.code] || warning.message;
}

module.exports = {metric, cards, effects, warningLabel, emptyMessage};
